import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[inputUpperCase]',
    standalone: false
})
export class UpperCaseDirective {
  private control: NgControl | null;

  constructor(
    private el: ElementRef,
  ) {
    this.control = inject(NgControl, { optional: true });
    // Defensive check for control availability
    if (!this.control) {
      console.warn('UpperCaseDirective: NgControl not available');
    }
  }

  @HostListener('input', ['$event']) public onEvent($event) {
    if (this.control && this.control.control) {
      let upper = this.el.nativeElement.value.toUpperCase();
      this.control.control.setValue(upper);
    }
  }

  @HostListener('blur') public onBlur() {
    // Pad number to 0 < 10
    if (this.control && this.control.control && this.el.nativeElement.getAttribute('format') === '00') {
      let val = this.el.nativeElement.value;
      if (val.trim() !== '' && !isNaN(val) && val < 10 && val.length < 2) {
        val = '0' + val;
        this.control.control.setValue(val);
      }
    }
  }
}
